import React from 'react';

import EditInstitutionAccount from '../../../holistic/components/EditInstitutionAccount';

export default function EditInstitutionAccountScreen() {
    return <EditInstitutionAccount />;
}
